<template>
  <el-form
    id="config"
    :size="size"
    :label-width="labelWidth"
    :label-position="labelPosition"
  >
    <el-form-item label="Version">
      <el-select v-model="form.version" @change="change">
        <el-option
          v-for="version in bundle.versions"
          :key="version"
          :label="version"
          :value="version"
        />
      </el-select>
    </el-form-item>

    <el-form-item v-if="bundle.package" :label="bundle.name">
      <el-select v-model="form.package" @change="change">
        <el-option
          v-for="version in packages[bundleId]"
          :key="version"
          :label="version"
          :value="version"
        />
      </el-select>
    </el-form-item>

    <component
      v-bind:is="component"
      :config.sync="form.config"
      @change="change"
    />
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import Laravel from './Config/Laravel'
import Node from './Config/Node'
import Php from './Config/Php'
import Python from './Config/Python'
import Ruby from './Config/Ruby'
import Wordpress from './Config/Wordpress'

export default {
  props: {
    bundleId: String,
    version: String,
    package: String,
    config: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String,
      default: 'mini'
    },
    labelWidth: {
      type: String,
      default: '155px'
    },
    labelPosition: {
      type: String,
      default: 'left'
    }
  },
  components: {
    Laravel,
    Node,
    Php,
    Python,
    Ruby,
    Wordpress
  },
  data () {
    return {
      form: {
        version: this.version,
        package: this.package,
        config: this.config
      }
    }
  },
  computed: {
    component () {
      return this.bundleId.charAt(0).toUpperCase() + this.bundleId.slice(1)
    },
    bundle () {
      return this.$root.bundles[this.bundleId]
    },
    ...mapState(['packages'])
  },
  methods: {
    change () {
      this.$emit('change')
      this.$nextTick(() => {
        this.$emit('update:version', this.form.version)
        this.$emit('update:package', this.form.package)
        this.$emit('update:config', this.form.config)
      })
    }
  },
  watch: {
    version (value) {
      this.form.version = value
    },
    package (value) {
      this.form.package = value
    },
    config (value) {
      this.form.config = value
    }
  }
}
</script>

<style lang="scss">
  #config {
    .el-select {
      width: 100%;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 5px;
    }
    .el-form-item--mini.el-form-item {
      &.readonly {
        margin-bottom: 15px;
        .el-form-item__error {
          right: 0;
        }
      }
    }
    .el-form-item__label {
      font-size: 13px;
    }
    .hidden.el-form-item {
      margin-bottom: 0;
      height: 0;
    }
  }
</style>
